var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarningFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9996 13.9996C11.3133 13.9996 13.9996 11.3133 13.9996 7.99961C13.9996 4.6859 11.3133 1.99961 7.9996 1.99961C4.68589 1.99961 1.9996 4.6859 1.9996 7.99961C1.9996 11.3133 4.68589 13.9996 7.9996 13.9996ZM7.99999 5.20006C7.85147 5.20006 7.70903 5.25906 7.60401 5.36408C7.49899 5.4691 7.43999 5.61153 7.43999 5.76006V8.00006C7.43999 8.14858 7.49899 8.29101 7.60401 8.39604C7.70903 8.50106 7.85147 8.56006 7.99999 8.56006C8.14851 8.56006 8.29095 8.50106 8.39597 8.39604C8.50099 8.29101 8.55999 8.14858 8.55999 8.00006V5.76006C8.55999 5.61153 8.50099 5.4691 8.39597 5.36408C8.29095 5.25906 8.14851 5.20006 7.99999 5.20006ZM7.99999 9.68006C7.88924 9.68006 7.78097 9.7129 7.68887 9.77443C7.59678 9.83597 7.52501 9.92343 7.48262 10.0258C7.44024 10.1281 7.42915 10.2407 7.45075 10.3493C7.47236 10.4579 7.5257 10.5577 7.60401 10.636C7.68233 10.7144 7.78211 10.7677 7.89074 10.7893C7.99937 10.8109 8.11197 10.7998 8.2143 10.7574C8.31662 10.715 8.40408 10.6433 8.46562 10.5512C8.52715 10.4591 8.55999 10.3508 8.55999 10.2401C8.55999 10.0915 8.50099 9.9491 8.39597 9.84408C8.29095 9.73906 8.14851 9.68006 7.99999 9.68006Z",
    fill: "#FFC775"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningFilled);
export default __webpack_public_path__ + "static/media/icon-warning-filled.0747849c67b2934737564bc993ead575.svg";
export { ForwardRef as ReactComponent };